export default {
    columns: {
        image: 'Image',
        updatedAt: 'Updated at',
        title: 'Title',
        status: 'State',
        megatrends: 'Mega-trends',
        macrotrends: 'Macro-trends',
        trendradars: 'Trend radars',
        innovationFields: 'Innovation-fields'
    }
}
